__turbopack_context__.v({
  "date": "RelatedEventCard-module-scss-module__QOPykq__date",
  "dateWrapper": "RelatedEventCard-module-scss-module__QOPykq__dateWrapper",
  "grid": "RelatedEventCard-module-scss-module__QOPykq__grid",
  "imageWrapper": "RelatedEventCard-module-scss-module__QOPykq__imageWrapper",
  "linegap": "RelatedEventCard-module-scss-module__QOPykq__linegap",
  "link": "RelatedEventCard-module-scss-module__QOPykq__link",
  "location": "RelatedEventCard-module-scss-module__QOPykq__location",
  "locationWrapper": "RelatedEventCard-module-scss-module__QOPykq__locationWrapper",
  "price": "RelatedEventCard-module-scss-module__QOPykq__price",
  "priceWrapper": "RelatedEventCard-module-scss-module__QOPykq__priceWrapper",
  "promoted": "RelatedEventCard-module-scss-module__QOPykq__promoted",
  "promotedWrapper": "RelatedEventCard-module-scss-module__QOPykq__promotedWrapper",
  "signalBadgeWrapper": "RelatedEventCard-module-scss-module__QOPykq__signalBadgeWrapper",
  "title": "RelatedEventCard-module-scss-module__QOPykq__title",
  "titleWrapper": "RelatedEventCard-module-scss-module__QOPykq__titleWrapper",
  "wrapper": "RelatedEventCard-module-scss-module__QOPykq__wrapper",
});
